import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom-v5-compat";
import { grey } from "../../utility/theme/palette";
import { useEventTracker } from "../../eventtracker/eventTrackerContext";

interface Props {
    url: string;
    selected: boolean;
    children: React.ReactNode;
}

export const AppBarButton = (props: Props) => {
    const navigate = useNavigate();
    const { trackEvent } = useEventTracker();

    return (
        <Stack sx={theme => ({
            backgroundColor: props.selected ? theme.palette.primary.light : "transparent",
            color: props.selected ? theme.palette.primary.main : grey[600],
            fontWeight: props.selected ? "bold" : "normal",
            border: props.selected ? "1px solid rgb(181, 191, 253)" : "initial",
            boxSizing: "border-box",
            borderRadius: 1,
            py: 1,
            px: 2,
            width: "max-content",
            "&:hover": {
                cursor: "pointer",
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark
            },
            transition: "* 0.3s ease-in-out"
        })}>
            <Typography onClick={() => {
                trackEvent("appbar", { action: "click", url: props.url });
                navigate(props.url);
            }} sx={{
                fontWeight: props.selected ? "bold" : "normal"
            }} variant="body2">
                {props.children}
            </Typography>
        </Stack>
    )
};